/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

$(window).scroll(function() {    
var scroll = $(window).scrollTop();
var product_gin_monaco_section = $("#product_gin_monaco_section").offset().top;
  console.log(scroll, product_gin_monaco_section);
  if(scroll == product_gin_monaco_section || scroll > product_gin_monaco_section)
  {
    $("#cart-bar").addClass('cart-bar--is-visible');
  }
  else {
    $("#cart-bar").removeClass('cart-bar--is-visible');
  }
    if ($(window).scrollTop() >= 200) {
        $(".p_img").addClass("vertical_p_img");
    }
  else {
    $(".p_img").removeClass("vertical_p_img");
  }
});

const videoElement = document.getElementById("myVideo");
const playPauseButton = document.querySelector('.video_icon');
videoElement.controls = false;
playPauseButton.addEventListener('click', () => {
	playPauseButton.classList.toggle('playing');
	if (playPauseButton.classList.contains('playing')) {
        videoElement.controls = false;
		videoElement.play();
      
	}
	else {
        videoElement.controls = false;
		videoElement.pause();
        
	}
});
videoElement.addEventListener('ended', () => {
	playPauseButton.classList.remove('playing');
});


jQuery(document).ready(function(){
    // This button will increment the value
    $('[data-quantity="plus"]').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $('[data-quantity="minus"]').click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
});

  
// var header = document.getElementById("myTab");
// var btns = header.getElementsByClassName("product_tab");
// for (var i = 0; i < btns.length; i++) {
//   btns[i].addEventListener("click", function() {
//   var current = document.getElementsByClassName("active");
//   current[0].className = current[0].className.replace(" active", "");
//   this.className += " active";
//   });
// }

  
$(document).ready(function(){
  $("#tab_1").click(function(){
    $(".product_slider_wrap.tab_2").hide();
    $(".product_slider_wrap.tab_1").show();
  });
  $("#tab_2").click(function(){
    $(".product_slider_wrap.tab_1").hide();
    $(".product_slider_wrap.tab_2").show();
  });
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
